import BorderBox from "./BorderBox";
import React from "react";
import {Layers, LayerTitles} from "./Layers";
import {CakeChoiceSummary} from "./HgCakeChoices";
import {cakeIsComplete, calculateSum, currency} from "./Helper";


export function HgCakeSummary({setCurrentGroup, currentGroup, config, cake, updateCake, isEdit, isDirty, isAddedToCart, addToCart}) {

    const Summary = CakeChoiceSummary(cake, config);
    const sum = calculateSum(cake, config);
    const cakeComplete = cakeIsComplete(cake, config);

    return <div className={"hg-cake-editor-summary"}>
        <div className={"hg-cake-editor-summary-cake"}>
            <BorderBox>
                <h2 style={{textAlign: 'center'}}>Ihre Torte</h2>
                {Layers.map((group, idx) => {
                    const enabled = cake[group];
                    return <div key={group} className={"hg-cake-editor-summary-item"}>
                        <h2
                            onClick={(e) => { if (enabled) { setCurrentGroup(group); } }}
                        >{LayerTitles[group]}</h2>
                        <Summary group={group} />
                    </div>;
                })}
                {sum > 0 && <div className={"hg-cake-editor-summary-cake__price"}>
                    <div className={"woocommerce-Price-amount amount"}>
                        {currency(sum)}
                    </div>
                    <div className={"info-message"}>inkl. MwSt.</div>
                </div>}
            </BorderBox>
        </div>
        <div className={"hg-cake-editor-cart-button"}>
            <span className={"hg-button"} style={{display: 'block'}}>
                {isAddedToCart &&
                    <button
                        style={{display: 'block', width: '100%'}}
                        onClick={(e) => {
                            document.location.href = config.cartUrl;
                        }} >
                        Zum Warenkorb gehen
                    </button>}
                {!isAddedToCart &&
                    <button
                        disabled={!(cakeComplete && isDirty)}
                        style={{display: 'block', width: '100%'}}
                        onClick={(e) => {
                            addToCart();
                        }} >
                        {isEdit && 'Torte aktualisieren'}
                        {!isEdit && 'In den Warenkorb legen'}
                    </button>}
            </span>
        </div>
    </div>;
}


// WEBPACK FOOTER //
// ./js/cake/HgCakeSummary.js